import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { FAVOURITE_ONBOARDING_STEPS } from '../../../mobile/components/OnboardingLayer/onboardingSteps';
var FavouritesUnlocked = /*#__PURE__*/function (_Component) {
  function FavouritesUnlocked() {
    var _this;
    _classCallCheck(this, FavouritesUnlocked);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FavouritesUnlocked, [].concat(args));
    _this._buttonHandler = function () {
      var _this$props = _this.props,
        dismissModal = _this$props.dismissModal,
        setOnboardingStep = _this$props.setOnboardingStep;
      dismissModal();
      setOnboardingStep(FAVOURITE_ONBOARDING_STEPS.FINISH);
    };
    return _this;
  }
  _inherits(FavouritesUnlocked, _Component);
  return _createClass(FavouritesUnlocked, [{
    key: "render",
    value: function render() {
      var render = this.props.render;
      return render({
        buttonHandler: this._buttonHandler
      });
    }
  }]);
}(Component);
export { FavouritesUnlocked as default };